import { LuDownload } from "react-icons/lu";
import documentImg from "../../../assets/images/Blue and Peach Gradient Facebook Profile Picture.png";

const MessageBubble = ({ message }) => {
  const { isRight, text, time } = message;

  // ✅ support both formats
  const mediaItems = message.media?.length
    ? message.media
    : (message.mediaUrls || []).map((url) => ({ url }));

  const isImageUrl = (url) =>
    /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(url.split("?")[0]);

  const isVideoUrl = (url) =>
    /\.(mp4|mov|avi|mkv|webm)$/i.test(url.split("?")[0]);

  const renderMedia = ({ url, type }, index) => {
    // ✅ MIME type check FIRST (most reliable)
    if (type?.startsWith("image/") || isImageUrl(url)) {
      return (
        <img
          key={index}
          src={url}
          className="img-fluid rounded mb-2"
          style={{ maxHeight: 220, maxWidth: "100%", objectFit: "contain" }}
          alt="attachment"
        />
      );
    }

    if (type?.startsWith("video/") || isVideoUrl(url)) {
      return (
        <video
          key={index}
          controls
          className="w-100 rounded mb-2"
          style={{ maxHeight: 240 }}
        >
          <source src={url} />
        </video>
      );
    }

    // 📄 Other files
    return (
      <div
        key={index}
        className="d-flex align-items-center gap-2 mb-2"
        style={{
          padding: "6px 8px",
          borderRadius: 8,
          background: "#f1f5f9",
        }}
      >
        <img src={documentImg} width={36} alt="file" />
        <a href={url} download target="_blank" rel="noreferrer">
          <LuDownload size={20} />
        </a>
      </div>
    );
  };

  return (
    <div
      className={`d-flex mb-3 ${
        isRight ? "justify-content-end" : "justify-content-start"
      }`}
    >
      <div
        style={{
          maxWidth: "70%",
          background: isRight ? "#dcf8c6" : "#f1f5f9",
          borderRadius: 12,
          padding: 10,
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        }}
      >
        {text && <div className="mb-2">{text}</div>}
        {mediaItems.map(renderMedia)}
        <div style={{ fontSize: 11, textAlign: "right", color: "#777" }}>
          {time}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
